export default __webpack_public_path__ + "static/personal-loans-2c182801b2c1c019bca1629af79accc4.webp";